var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFormBuilderSelected(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.33325 2.66634C2.96506 2.66634 2.66659 2.96482 2.66659 3.33301V12.6663C2.66659 13.0345 2.96506 13.333 3.33325 13.333H12.6666C13.0348 13.333 13.3333 13.0345 13.3333 12.6663V3.33301C13.3333 2.96482 13.0348 2.66634 12.6666 2.66634H3.33325ZM1.33325 3.33301C1.33325 2.22844 2.22868 1.33301 3.33325 1.33301H12.6666C13.7712 1.33301 14.6666 2.22844 14.6666 3.33301V12.6663C14.6666 13.7709 13.7712 14.6663 12.6666 14.6663H3.33325C2.22868 14.6663 1.33325 13.7709 1.33325 12.6663V3.33301Z",
    fill: "rgb(36, 150, 255)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.33325 5.99967C1.33325 5.63148 1.63173 5.33301 1.99992 5.33301H13.9999C14.3681 5.33301 14.6666 5.63148 14.6666 5.99967C14.6666 6.36786 14.3681 6.66634 13.9999 6.66634H1.99992C1.63173 6.66634 1.33325 6.36786 1.33325 5.99967Z",
    fill: "rgb(36, 150, 255)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.99992 5.33301C6.36811 5.33301 6.66658 5.63148 6.66658 5.99967V13.9997C6.66658 14.3679 6.36811 14.6663 5.99992 14.6663C5.63173 14.6663 5.33325 14.3679 5.33325 13.9997V5.99967C5.33325 5.63148 5.63173 5.33301 5.99992 5.33301Z",
    fill: "rgb(36, 150, 255)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFormBuilderSelected);
export default __webpack_public_path__ + "static/media/form-builder-selected.0163046c4314b2490e8efc2cea81a6c6.svg";
export { ForwardRef as ReactComponent };